import { useContext } from 'react';
import { CursorContext } from '../context/CursorContext';

const useCursor = () => useContext(CursorContext);

export default useCursor;